document.getElementById('toggle-menu').addEventListener('click', function () {
	var headerCL = document.getElementById('masthead');
	if (document.documentElement.style.overflowY == 'hidden') {
		document.documentElement.style.overflowY = 'auto';
		headerCL.classList.remove('has-white-background-color');
	} else {
		document.documentElement.style.overflowY = 'hidden';
		headerCL.classList.add('has-white-background-color');
	}
});

/* Anchor scroll to... */

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', function (e) {
		e.preventDefault();
		
		const y = document.querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset + -100;
		
		window.scrollTo({top: y, behavior: 'smooth'});
		
		/*document.querySelector(this.getAttribute('href')).scrollIntoView({
			behavior: 'smooth'
		});*/
	});
});
